import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.css";
import img13 from "../assets/img13.jpeg";
import img1 from "../assets/img1.jpeg";
import img2 from "../assets/img2.jpeg";
import img3 from "../assets/img3.jpeg";
import img4 from "../assets/img4.jpeg";
import img5 from "../assets/img5.jpeg";
import img14 from "../assets/img8.jpeg";
import img10 from "../assets/img14.jpeg";
import img11 from "../assets/img9.jpeg"; 
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

const Home = () => {
  
const navigate = useNavigate();


const [currentFAQ, setCurrentFAQ] = React.useState(0);

const faqData = [
  {
    question: "What classes does the school offer?",
    answer: "We offer education from Nursery to Class 12 with modern facilities."
  },
  {
    question: "How can I apply for admission?",
    answer: "You can apply online or visit the school campus."
  },
  {
    question: "Do you provide transport facilities?",
    answer: "Yes, we provide safe and secure transport services."
  },
  {
    question: "Are extracurricular activities available?",
    answer: "Yes, we offer sports, music, dance and more."
  }
];


const nextFAQ = () => {
  setCurrentFAQ((prev) => (prev + 1) % faqData.length);
};

const prevFAQ = () => {
  setCurrentFAQ((prev) =>
    prev === 0 ? faqData.length - 1 : prev - 1
  );
};

  return (
    <>
    <div>
      <Helmet>
  <title>Saraswati Vidya Mandir | Best School for Quality Education</title>
  <meta
    name="description"
    content="Saraswati Vidya Mandir offers quality education from Nursery to Class 12 with smart classes, experienced teachers, and holistic development."
  />
</Helmet>
      {/* 🔥 HERO */}
      <section className={styles.hero}>
        <h1 className={styles.title}>Saraswati Vidya Mandir</h1>
        <p className={styles.subtitle}>
          ज्ञान, अनुशासन और संस्कार का संगम
        </p>
        <Link to="/contact">
          <button className={styles.btn}>Apply Now</button>
        </Link>
      </section>

{/* 📘 ABOUT */}
<section className={styles.aboutSection}>
  <div className={styles.aboutContainer}>
    
    <div className={styles.aboutImage}>
      <img
        src={img13}
        alt="School"
        className={styles.img}  
      />
    </div>

    <div className={styles.aboutContent}>
      <h2 className={styles.heading}>About Our School</h2>
   <p className={styles.aboutText}>
  Saraswati Vidya Mandir is a premier educational institution committed to
  nurturing young minds with a perfect blend of academic excellence,
  discipline, and moral values. Our school focuses on the holistic
  development of students by providing a supportive and inspiring
  environment where they can grow intellectually, socially, and
  emotionally. 
</p>

<ul className={styles.list}>
  <li>Highly qualified and experienced teaching staff</li>
  <li>Smart classrooms with modern digital learning tools</li>
  <li>Well-equipped science and computer laboratories</li>
  <li>Focus on discipline, values, and character building</li>
  <li>Regular co-curricular and extracurricular activities</li>
  <li>Sports facilities for physical development</li>
 
</ul>
    </div>

  </div>
</section>

      {/* 🏫 FACILITIES */}
      <section className={styles.infoSection}>
        <h2 className={styles.heading}>Our Facilities</h2>

        <div className={styles.infoGrid}>
          <div className={styles.infoCard}>
            <div className={styles.icon}>📚</div>
            <h3>Smart Classes</h3>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.icon}>🧪</div>
            <h3>Science Lab</h3>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.icon}>💻</div>
            <h3>Computer Lab</h3>
          </div>

          <div className={styles.infoCard}>
            <div className={styles.icon}>⚽</div>
            <h3>Sports</h3>
          </div>
        </div>
      </section>

      {/* 🎓 ADMISSION BANNER */}
      <section className={styles.banner}>
        <div className={styles.overlay}>
          <h2 className={styles.bannerTitle}>
            Admissions Open for <span className={styles.red}>2026</span>
          </h2>
          <p>Give your child the best education environment.</p>

          <Link to="/contact">
            <button className={styles.btn}>Apply Today</button>
          </Link>
        </div>
      </section>

      {/* 🖼️ GALLERY */}
      <section className={styles.gallerySection}>
  <h2 className={styles.heading}>Gallery</h2>

  <div className={styles.galleryGrid}>
    <img src={img1} alt="" className={styles.galleryImg} />
    <img src={img2} alt="" className={styles.galleryImg} />
    <img src={img3} alt="" className={styles.galleryImg} />
    <img src={img4} alt="" className={styles.galleryImg} />
    <img src={img5} alt="" className={styles.galleryImg} />
    <img src={img13} alt="" className={styles.galleryImg} />
    <img src={img14} alt="" className={styles.galleryImg} />
    <img src={img10} alt="" className={styles.galleryImg} />
    <img src={img11} alt="" className={styles.galleryImg} />
  </div>

  <Link to="/gallery">
    <button className={styles.btn}>View More</button>
  </Link>
</section>
        
<section className={styles.whyTimeline}>
  <h2 className={styles.heading}>Why Choose Us</h2>

  <div className={styles.timeline}>

    {[
      {
        icon: "🎓",
        title: "Expert Faculty",
        desc: "Highly qualified teachers focused on excellence."
      },
      {
        icon: "💡",
        title: "Smart Learning",
        desc: "Modern digital classrooms with smart tools."
      },
      {
        icon: "🛡️",
        title: "Safe Campus",
        desc: "Secure environment with discipline and care."
      },
      {
        icon: "🏆",
        title: "All-round Growth",
        desc: "Academics + sports + personality development."
      }
    ].map((item, i) => (

      <div key={i} className={styles.timelineItem}>

        <div className={styles.timelineIcon}>
          {item.icon}
        </div>

        <div className={styles.timelineContent}>
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
        </div>

      </div>

    ))}

  </div>
</section>
      
<section className={styles.testimonialSection}>
  
  <h2 className={styles.heading}>What Parents Say</h2>
  <p className={styles.subtext}>
    Real feedback from our respected parents about education, discipline and growth.
  </p>

  <div className={styles.slider}>
    <div className={styles.slideTrack}>

      {[
        {text: "Excellent school with great teachers and discipline.", name: "Rajesh Kumar"},
        {text: "My child has improved academically and socially.", name: "Neha Sharma"},
        {text: "Best environment for overall development.", name: "Amit Verma"},
        {text: "Highly recommend for quality education and values.", name: "Priya Singh"},
        {text: "Great focus on discipline and character building.", name: "Sunita Gupta"},
        {text: "My child loves the teachers and learning environment.", name: "Rakesh Mehta"},
      ].map((item, i) => (
        <div key={i} className={styles.card}>
          
          <div className={styles.quote}>“</div>

          <p className={styles.text}>{item.text}</p>

          <div className={styles.footer}>
            <div className={styles.avatar}></div>
            <h4>{item.name}</h4>
          </div>

        </div>
      ))}

    </div>
  </div>

</section>



<section className={styles.faqSlider}>
  <h2 className={styles.heading}>Frequently Asked Questions</h2>

  <div className={styles.faqCard}>

    {/* LEFT ARROW */}
    <button className={styles.arrowLeft} onClick={prevFAQ}>
      ❮
    </button>

    {/* CONTENT */}
    <div className={styles.faqContent}>
      <h3>{faqData[currentFAQ].question}</h3>
      <p>{faqData[currentFAQ].answer}</p>
    </div>

    {/* RIGHT ARROW */}
    <button className={styles.arrowRight} onClick={nextFAQ}>
      ❯
    </button>

  </div>
</section>



<section className={styles.ctaSection}>

  <div className={styles.ctaOverlay}></div>

  <div className={styles.ctaContent}>

    <span className={styles.tag}>Admissions Open 2026</span>

    <h2>Shape Your Child’s Bright Future Today</h2>

    <p>
      At Saraswati Vidya Mandir, we combine education, discipline, and values
      to build future-ready students with strong character and confidence.
    </p>

    <div className={styles.ctaBtns}>
   
     <button 
  className={styles.primaryBtn}
  onClick={() => navigate("/contact")}
>
  Apply Now
</button>

    </div>

  </div>

</section>


    </div>
    </>
  );
};

export default Home;